import { render, staticRenderFns } from "./ModalUsuarios.vue?vue&type=template&id=317da7fe&"
import script from "./ModalUsuarios.vue?vue&type=script&lang=js&"
export * from "./ModalUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports